export const TUTORIAL_EVENT_NAME = 'tutorial-event';
